import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

export const UNIFIED_CLIP_VECTOR_VERSION = 'unified-v1';

export const useSimilarLotsUnifiedClipExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.SimilarLotsUnifiedClip,
        AmplitudeVariants.SimilarLotsUnifiedClip.Treatment
    );
